<template>
  <div class="picture-setting-wrap clearfix">
    <div class="tile is-parent">
      <article class="tile is-child box flex-3 clearfix">
        <div class="image-wrapper">
          <div class="image" id="hotShotImg" style="width: 500px;">
            <image-component :image="identification.image" :width="500" ></image-component>
            <div class="initial-score">分数：{{imageInfo.score}}</div>
            <div v-if="index !== blockIndex" class="rect" v-for="(item, index) in identification.boxList" :style="getStyle(item.box)">
              <p>{{item.categoryName}}</p>
              <p>{{item.colorName}}</p>
            </div>
          </div>
        </div>
        <div class="tabs-wrapper fleft">
          <el-tabs v-model="activeName" type="card" @tab-click="onTabClick">
            <el-tab-pane label="识别区块" name="identification">
              <div class="identification-wrapper" :style="tabWrapperStyel" style="width: 635px;">
                <div class='identification-wrap' v-for='(idItem,index) in identification.boxList' :style="borderStyle(index)">
                  <div class="block">
                    <div class="control">
                      <label class="label inline-block r-top">类目：</label>
                      <span class="inline-block width-2">
                        <el-select v-model="idItem.categoryName" filterable placeholder="请选择" @change="onCategoryChange(idItem.categoryName, index)">
                            <el-option
                              v-for="(item, _index) in allOpts.categories"
                              :key="_index"
                              :label="item.name"
                              :value="item.name">
                            </el-option>
                        </el-select>
                      </span>
                    </div>
                    <div class="control">
                      <label class="label inline-block r-top">颜色：</label>
                      <span class="inline-block width-2">
                        <el-select v-model="idItem.colorName" filterable placeholder="请选择" @change="onColorChange(idItem.colorName, index)">
                            <el-option
                              v-for="(item,_index) in allOpts.colors"
                              :key="_index"
                              :label="item.name"
                              :value="item.name">
                            </el-option>
                        </el-select>
                      </span>
                    </div>
                    <div class="control">
                      <button class="button is-info" @click="onFixBlock(index)">调整区块</button>
                    </div>
                  </div>
                  <div class="block" style="width: 565px;">
                    其他识别结果：<span>{{idItem.others}}</span>  
                  </div>
                  <div class="block">
                    <button class="button is-link mg-left" @click="onSimilarClick(idItem)">相似商品></button>
                    <button class="button is-danger mg-left" @click="onDeleteBlock(index)">删除区块</button>
                  </div>
                </div>
                <div class="block-button-area" style="margin-top: 10px;">
                  <button class="button is-info mg-left width-2" @click="onAddBlock">+新增区块</button>
                </div>
              </div>

            </el-tab-pane>
            <el-tab-pane label="相似商品列表" name="similarGoods">
              <div class="similar-wrapper" style="width: 635px;">
                <div class="category-wrapper" v-for="(item, index) in list">
                  <!-- 一维 -->
                  <div class=""><span class="label inline-block" style="font-size: 18px;">{{item.categoryName}} {{item.colorName}}</span><span>{{`(${item.onlineCount && item.onlineCount || 0}/${item.totalCount})`}}</span></div>
                  <!-- <div class="similar-button">
                    <button class="button is-primary mg-left width-2" @click="onRecrew">重新抓取>></button>
                  </div> -->
                  
                  <div v-for="(subItem, subIndex) in item.goodsList" class="item clearfix" style="margin-top: 10px; border-bottom: 1px solid #aaa;">
                    <div class="crew-time">{{subItem.createTime}} 抓取</div>
                    <!-- 二维 -->
                    <div class="image-wrapper fleft" v-if="subItem.image && subItem.image.image">
                      <image-component :image="subItem.image && subItem.image" :width="100" :height="100"></image-component>
                    </div>
                    <div class="goods-info fleft" style="margin-left: 10px; width:500px; position:relative;">
                      <p class="category-row"><span v-if="subItem.isRepeat == 1" style="color: #f00">[重复商品]</span>{{subItem.name}}</p>
                      <p class="category-row"><a :href="subItem.link">{{subItem.link}}</a></p>
                      <p class="category-row">{{subItem.category}}</p>
                      <p class="category-row">¥ {{subItem.price}}</p>
                      <div class="button-area" v-if="subItem.isRepeat != 1">
                        <button v-if="subItem.status != 2" class="button is-danger mg-left" @click="onChangeStatus(2,subItem)">删除</button>
                        <button v-if="subItem.status != 1" class="button is-warning mg-left" @click="onChangeStatus(1,subItem)">上架</button>
                        <button v-if="subItem.status != 0" class="button is-primary mg-left" @click="onChangeStatus(0,subItem)">撤回</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="图片信息" name="pictureSource">
              <div class="picture-info block" style="width: 635px;">
                <div class="info-row"><span class="row-title label inline-block">动态ID:</span><span v-for="(item, index) in imageInfo.articleIds">
                  <a :href="`#/cyzsArticle/articleList?articleId=${item}`" target="_blank">{{item}}</a>
                  <span v-if="index !== imageInfo.articleIds.length - 1">、</span></span></div>
                <div class="info-row"><span class="row-title label inline-block">来源ICON:</span><span v-for="(item, index) in imageInfo.bloggerNames">{{item}}<span v-if="index !== imageInfo.bloggerNames.length - 1">、</span></span></div>
                <div class="info-row"><span class="row-title label inline-block">图片分数:</span><span>{{imageInfo.score}}</span></div>
                <div class="info-row"><span class="row-title label inline-block">来源:</span><span>{{imageInfo.sourceTypeText}}</span></div>
                <div class="info-row"><span class="row-title label inline-block">账号:</span><span>{{imageInfo.accountName}}</span></div>  
                <div class="info-row"><span class="row-title label inline-block">图片状态:</span><span v-if="imageInfo.status === 0">未修改</span><span v-if="imageInfo.status === 1">已修改</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="JSON Preview" name="jsonPreview">
              <div class="json-preview-wrapper" style="width: 635px;">
                <json-preview :json-obj="detect"></json-preview>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </article>
    </div>
    <div class="footer" style="text-align: center;">
      <button class="button is-info mg-left" @click="goBack()">返回</button>
      <button class="button is-primary mg-left" @click="onSaveFix()">保存设置</button>
    </div>
  </div>
</template>
<script type="text/babel">
  import $ from 'expose-loader?$!jquery';
  import 'COMMON/imgAreaSelect/imgareaselect-default.css';
  import 'COMMON/imgAreaSelect/jquery.imgareaselect.js';
  import jsonPreview from 'COMMON/jsonPreview';

  export default {
    components:{
      jsonPreview,
    },
    computed:{
      image(){
        let width = 500,
            height = width / (this.identification.width / this.identification.height);
        return {
          image:this.identification.image,
          width:width,
          height:height
        }
      },
      tabWrapperStyel() {
        return {
          height: document.documentElement.clientHeight + 'px',
        }
      },
      
    },
    data(){
      return {
        requestParamImg: '',
        initialScore: '',
        imageInfo: {},
        activeName: 'identification',
        list :[],
        identification: {
          image: {},
          boxList: [],
        },
        imgSelect: null,
        blockIndex: null,
        allOpts: { // 初始化返回的所有数据；
          categories: [],
          colors: []
        },
        detect: {},
        blockParams: {},
      }
    },
    mounted(){
      if (this.$route.query.image) {
        this.requestParamImg = this.$route.query.image;
      }
      if (this.$route.query.score) {
        this.initialScore = this.$route.query.score;
      }
      this.getImageInitBox();
      this.getImageInfo();
      this.getImageInit();
      this.getImageDetectPriew();
    },
    events:{

    },
    props:{

    },
    methods:{
      getStyle(box){
      let positionStyle = this.getPositionStyle(box)

        return Object.assign({},positionStyle)
      },
      borderStyle(index) {
        if (index === this.blockIndex) {
          return {
            border: '3px dashed #f00'
          }
        }
      },
      getPositionStyle(box){
        let _width = box.width;
        let _height = box.height;
        let _x = box.x1;
        let _y = box.y1
        return {
          top: _y+'px',
          left: _x+'px',
          width: _width+'px',
          height: _height+'px'
        }
      },
      // 初始化 区块；
      getImageInitBox() {
        let _params = {
          image: this.requestParamImg,
        };
        let that = this
        HttpRequest.get("/admin.php?method=fashion.getImageBox",_params).then(response => {
          if (response.data) {
            this.getImageSimilarGoodsList(this.blockParams);
            this.identification = response.data;

            let _width = this.identification.image.width;
            _.each(this.identification.boxList, (item, index) => {
              item.box.x1 = this.getCurrentSize(_width, item.box.x1)
              item.box.y1 = this.getCurrentSize(_width, item.box.y1)
              item.box.x2 = this.getCurrentSize(_width, item.box.x2)
              item.box.y2 = this.getCurrentSize(_width, item.box.y2)
              item.box.width = this.getCurrentSize(_width, item.box.width)
              item.box.height = this.getCurrentSize(_width, item.box.height)
            })
          }
        })
      },
      // 获取图片信息初始化；
      getImageInfo() {
        let params = {
          image: this.requestParamImg,
        }
        HttpRequest.get("/admin.php?method=fashion.getImage",params).then(response => {
          this.imageInfo = response.data;
        })
      },
      // 获取类目颜色；
      getImageInit() {
        HttpRequest.get("/admin.php?method=fashion.getImageInit",{}).then(response => {
          if (response.data) {
            this.allOpts.categories = response.data.categorys;
            this.allOpts.colors = response.data.colors;
          }  
        })
      },
      // 获取相似商品列表；
      getImageSimilarGoodsList() {
        let _params = {
          image: this.requestParamImg,
          boxId: this.blockParams.boxId && this.blockParams.boxId || '',
        }
        HttpRequest.get("/admin.php?method=fashion.getImageGoodsList",_params).then(response => {
          if (response.data) {
            this.list = _.toArray(response.data.list);
          }
        })
      },
      // 获取 json priew ;
      getImageDetectPriew() {
        let _params = {
          image: this.requestParamImg,
        }
        HttpRequest.get("/admin.php?method=fashion.getImageDetect",_params).then(response => {
          if (response.data) {
            this.detect = response.data.detect;
          }
        })
      },
      onFixBlock(index) {
        this.blockIndex = index;
        if (this.identification.boxList[index] && this.identification.boxList[index].box.x1) {
          this.bindImageSelect(this.identification.boxList[index].box)
        } else {
          this.bindImageSelect()
        }
      },
      formatToMap(_oriData) {
        return 500/this.identification.width *_oriData;
      },
      onSaveFix() {
        let _width = this.identification.image.width;
        this.identification = JSON.parse(JSON.stringify(this.identification));
        let _requestObj = Object.assign({}, this.identification);
        _requestObj = JSON.parse(JSON.stringify(_requestObj));
        _.each(_requestObj.boxList, (item, index) => {
          item.box.x1 = this.returnToOriginSize(_width, item.box.x1);
          item.box.x2 = this.returnToOriginSize(_width, item.box.x2);
          item.box.y1 = this.returnToOriginSize(_width, item.box.y1);
          item.box.y2 = this.returnToOriginSize(_width, item.box.y2);
          item.box.width = this.returnToOriginSize(_width, item.box.width);
          item.box.height = this.returnToOriginSize(_width, item.box.height);
        })
        _requestObj.boxList = JSON.stringify(_requestObj.boxList);
        let _params = {
          image: this.identification.image.image,
          boxList: _requestObj.boxList,
        }
        HttpRequest.post("/admin.php?method=fashion.doSaveImageBox",_params).then(response => {
          if (response.data.success) {
            this.$message("保存成功！")
            this.getImageInitBox();
            this.getImageInfo();
            this.getImageSimilarGoodsList();
            this.getImageDetectPriew();
          }
        })
      },
      onSimilarClick(item) {
        this.blockParams.boxId = item.boxId;
        this.activeName = 'similarGoods';
        this.getImageSimilarGoodsList();
      },
      onDeleteBlock(_index) {
        this.identification = JSON.parse(JSON.stringify(this.identification));
        this.identification.boxList.splice(_index, 1)
      },
      onColorChange(val, index) {
        this.identification.boxList[index].colorName = val;
      },
      onCategoryChange(val, index) {
        this.identification.boxList[index].categoryName = val;
      },
      onAddBlock() {
        const newParams = {
          categoryName: '',
          colorName: '',
          box: {x1: 0, y1: 0, x2: 60, y2: 60, width: 60, height: 60},
        }
        this.identification.boxList.push(newParams)
        
        this.blockIndex = this.identification.boxList.length - 1;
        this.onFixBlock(this.blockIndex);
      },
      bindImageSelect(data = {}) {
        if (!(Object.keys(data).length)) {
          data = {x1: 0, y1: 0, x2: 60, y2: 60, width: 60, height: 60}
        }
        let that = this
        let obj = {
          handles: true,
          onSelectEnd(img, selection) {
            if (selection.width > 0 && selection.height > 0) {
              that.identification.boxList[that.blockIndex].box = selection;
            }
          }
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.imgSelect = $('#hotShotImg img').imgAreaSelect(Object.assign(data, obj, {instance: true}));
              this.imgSelect.setOptions({resizable: true})
          }, 500)
        })
      },
      onRecrew() {},
      goBack() {
        let _fromWhere = this.$route.query.fromWhere && this.$route.query.fromWhere || '';
        let _name;
        if (_fromWhere === 'article') {
          _name = 'articleList';
        }
        if (_fromWhere === 'audit') {
          _name = 'pictureAudit';
        }
        this.$router.push({
          name: _name,
          query: this.$route.query,
        })
      },
      // 相似商品操纵；
      onChangeStatus(actionType, item) {
        let params = {}
        params = {
          actionType:actionType,
          ids:[item.id]
        }
        HttpRequest.post('/admin.php?method=fashion.operateSimilaryGoods',params).then(response => {
          if(response.data.success){
            this.$message("操作成功!")
            this.getImageSimilarGoodsList()
          }
        })
      },
      getCurrentSize(originWidth, originX1) {
        return originX1.toFixed(2) * (500/originWidth.toFixed(2));
      },
      returnToOriginSize(originWidth, originX1) {
        return originX1.toFixed(2) / (500/originWidth.toFixed(2));
      },
      onTabClick(_requestObj) {
        if (_requestObj.name === 'similarGoods') {
          this.blockParams.boxId = '';
          this.getImageSimilarGoodsList();
        }
      },
    },
    destroyed() {
      this.imgSelect && this.imgSelect.remove();
    },
  }
</script>
<style lang="less" scoped>
  .picture-setting-wrap {
    .image-wrapper{
      float: left;
      .image{
        position: relative;
      }
    }
    .tabs-wrapper{
      margin-left: 20px;
    }
    .identification-wrapper{
      overflow-y: auto;
    }
    .identification-wrap {
      position: relative;
      background: #f2f2f2;
      padding: 20px 14px;
      margin-bottom: 20px;
    }
    .rect {
      position: absolute;
      color:#fff;
      font-size: 18px;
      border: 3px dashed #333;
      // z-index: 4;
    }
    .initial-score {
      color:  #000;
      position: absolute;
      font-size: 18px;
      left: 0;
      top: 0;
    }
    .picture-info{
      padding: 25px;
      .info-row{
        margin-bottom: 20px;
        .row-title{
          font-weight: 900;
          margin-right: 10px;

        }
      }
    }
    .button-area {
      position: absolute;
      right: 20px;
      bottom: 0;
    }
    .category-wrapper {
      width: 630px;
      .item{
        padding-bottom: 10px;
        box-sizing: border-box;
      }
    }
    .category-row{
      margin-bottom: 5px;
    }
    .json-preview-wrapper{
      width: 635px;
    } 
  }
</style>
